import { useTranslation } from "react-i18next"
import { ARTICLE_VIDEO_CONST } from "./ArticleVideo.const"

import styles from "./ArticleVideo.module.scss"

const { tNamespace, tPath } = ARTICLE_VIDEO_CONST

export type ArticleVideoProps = {
    attrs: {
        href: string
        payload: {
            fileName: string
            fileType: string
        }
    }
}

export const ArticleVideo = (props: ArticleVideoProps) => {
    const { t } = useTranslation(tNamespace)
    const {
        attrs: { href, payload }
    } = props

    return (
        <video className={styles.articleVideo} controls title={payload.fileName}>
            <source src={href} type={payload.fileType} />
            {t(tPath.warning)}
        </video>
    )
}
